
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import './table.scss';
import { IconDelete, IconEdit } from '../../../icons/Icon';
import MinSingleSelect from '../MinSingleSelect';
import { useState } from 'react';
import { formatCost } from '../../../utils/format';
import PlanRevisedQtyTableCell from './PlanRevisedQtyTableCell';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { fetchApls } from '../../../services/kitchenIndentProductionPlanSlice';
import AddMogTableRow from './AddMogTableRow';
import { toast } from 'react-toastify';

interface KitchenIndentTableProps {
  dayPartMogList: any;
  dayPartCode: string;
  kitchenSectionCode: string;
  isEditable: boolean;
  showAddMog: boolean;
  setShowAddMog: React.Dispatch<React.SetStateAction<boolean>>;
  editMogCode: string;
  setEditMogCode: React.Dispatch<React.SetStateAction<string>>;
  handleDeleteMog: (kitchensectioncode: string, daypartcode: string, mogcode: string) => void;
  handleSaveKitchenIndent: (mogdetails: object) => void;
  handleAddMog: (mogcode: string) => void;
}


const KitchenIndentTable: React.FC<KitchenIndentTableProps> = ({ dayPartMogList, dayPartCode, kitchenSectionCode, isEditable, showAddMog, setShowAddMog, editMogCode, setEditMogCode, handleDeleteMog, handleSaveKitchenIndent, handleAddMog }): JSX.Element => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [aplOptions, setAplOptions] = useState<object[]>([]);

  const handleEditApl = (mogcode: string) => {
    setEditMogCode("");
    dispatch(fetchApls({ mogcode })).unwrap().then((res: any) => {
      if (res.length < 2) {
        toast('Only one APL available for this MOG', { type: "info" });
      }
      else {
        setAplOptions(res);
        setEditMogCode(mogcode)
      }
    }).catch((error) => console.log("getAPl API error", error));
  }

  const handleSaveMogQty = (qtykg: string, mogcode: string, articlenumber: string) => {
    const mogdetails = {
      mogcode,
      articlenumber,
      revisedquantity: +qtykg,
    }
    handleSaveKitchenIndent(mogdetails);
  }

  const handleSaveApl = (mogcode: string, articlenumber: string, revisedquantity: number) => {
    const mogdetails = {
      mogcode,
      articlenumber,
      revisedquantity,
    }
    handleSaveKitchenIndent(mogdetails);
  }

  // const showAplOptions = (recipemog: any, editmogcode: string) => {
  //   if (recipemog?.articlenumber) {
  //     if (editmogcode?.includes(recipemog?.mogcode)) {
  //       return (<div>
  //         <MinSingleSelect
  //           options={aplOptions?.length ? aplOptions?.map((apl: any) => { return { label: `${apl?.articledescription} (₹ ${apl?.articlecost ? formatCost(apl?.articlecost, 2) : 0}) (${apl?.uom?.toLowerCase()}) `, value: apl?.articlenumber } }) : [{ label: "Please Select MOG", value: 0 }]}
  //           defaultValue={recipemog?.articlenumber}
  //           onChange={(e) => handleSaveApl(recipemog?.mogcode, e.target.value as string, recipemog?.revisedquantity)}
  //           placeholder='Select apl'
  //         />
  //       </div>)
  //     } else {
  //       return (<div className="flex justify-content-between align-items-center">
  //         <div>{recipemog?.aplname} {`(₹ ${recipemog?.aplcost ? formatCost(recipemog?.aplcost, 2) : 0})`}{recipemog?.apluom ? `(${recipemog?.apluom?.toLowerCase()})` : null}</div>
  //         {isEditable && <button className="edit-btn ml-16" disabled={!isEditable} onClick={() => handleEditApl(recipemog?.mogcode)} ><IconEdit /></button>}
  //       </div>)
  //     }
  //   } else {
  //     return (<div>NA</div>)
  //   }
  // }

  const showAplOptions = (recipemog: any, editmogcode: string) => {
    if (recipemog?.articlenumber) {
      if (editmogcode?.includes(recipemog?.mogcode)) {
        return (
          <div>
            <MinSingleSelect
              options={
                aplOptions?.length
                  ? aplOptions?.map((apl: any) => {
                    return {
                      label: `${apl?.articledescription} (₹ ${apl?.articlecost ? formatCost(apl?.articlecost, 2) : 0
                        }) (${apl?.uom?.toLowerCase()})`,
                      value: apl?.articlenumber,
                    };
                  })
                  : [{ label: "Please Select MOG", value: 0 }]
              }
              defaultValue={recipemog?.articlenumber}
              onChange={(e) =>
                handleSaveApl(
                  recipemog?.mogcode,
                  e.target.value as string,
                  recipemog?.revisedquantity
                )
              }
              placeholder="Select apl"
            />
          </div>
        );
      } else {
        return (
          <div className="flex justify-content-between align-items-center">
            <div>
              {recipemog?.aplname} (₹{" "}
              {recipemog?.aplcost ? formatCost(recipemog?.aplcost, 2) : 0})
              {recipemog?.apluom ? `(${recipemog?.apluom?.toLowerCase()})` : null}
            </div>
            {isEditable && (
              <button
                className="edit-btn ml-16"
                disabled={!isEditable}
                onClick={() => handleEditApl(recipemog?.mogcode)}
              >
                <IconEdit />
              </button>
            )}
          </div>
        );
      }
    } else {
      return <div>NA</div>;
    }
  };


  return (
    <div className="table-wrapper KitchenIndentTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 440 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className="text-center">
                <Typography variant="h6" className="table-title">
                  ID
                </Typography>
              </TableCell>
              <TableCell className="text-left">
                <Typography variant="h6" className="table-title">
                  MOG Name
                </Typography>
              </TableCell>
              <TableCell className="text-center">
                <Typography variant="h6" className="table-title">
                  Plan Qty (Kg)
                </Typography>
              </TableCell>
              <TableCell className="text-center">
                <Typography variant="h6" className="table-title">
                  Revised Qty (Kg)
                </Typography>
              </TableCell>
              <TableCell className="text-left">
                <Typography variant="h6" className="table-title">
                  APL (Standard Cost per Kg)
                </Typography>
              </TableCell>
               <TableCell>
                <Typography variant="h6" className="table-title">
                   Category Name
                </Typography>
              </TableCell>
               <TableCell className="text-center">
                <Typography variant="h6" className="table-title">
                   Article Type
                </Typography>
              </TableCell>
              <TableCell className="text-center">
                <Typography variant="h6" className="table-title">
                  Indent Cost
                </Typography>
              </TableCell>
              <TableCell className="text-center">
                <Typography variant="h6" className="table-title">
                  Action
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dayPartMogList?.length ? dayPartMogList?.map((recipemog: any, mogIndex: number) => {
              return (
                <TableRow key={mogIndex}>
                  <TableCell className="text-center">REQ-000{++mogIndex}</TableCell>
                  <TableCell className="text-left">{recipemog?.name}</TableCell>
                  {isEditable ? <>
                    <PlanRevisedQtyTableCell key={mogIndex} recipemog={recipemog} handleSaveMogQty={handleSaveMogQty} />
                  </> : <>
                    <TableCell className='grey-bg'>
                      {!recipemog?.isdeletable ? formatCost(recipemog?.planquantity, 3) : "-"}
                    </TableCell>
                    <TableCell>
                      {recipemog?.revisedquantity ? formatCost(recipemog?.revisedquantity, 3) : 0}
                    </TableCell>
                  </>
                  }
                  <TableCell className="text-left">
                    {showAplOptions(recipemog, editMogCode)}
                  </TableCell>
                   <TableCell>
                    {recipemog?.categoryname || "-"}
                  </TableCell>
                  <TableCell className="text-center">
                    {recipemog?.shelflifecategory || "-"}
                  </TableCell>
                  <TableCell>₹ {recipemog?.cost ? formatCost(recipemog?.cost, 2) : 0}</TableCell>
                  <TableCell>{recipemog?.isdeletable && isEditable ? <button onClick={() => handleDeleteMog(kitchenSectionCode, dayPartCode, recipemog?.mogcode)} className="delete-btn"><IconDelete /></button> : "-"}</TableCell>
                </TableRow>
              )
            }) : <TableRow><TableCell colSpan={9} className="grey-bg center">No MOGs are found</TableCell></TableRow>}
            {showAddMog && <AddMogTableRow mogList={dayPartMogList} setShowAddMog={setShowAddMog} handleAddNewMog={handleAddMog} />}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </div>
  );
};

export default KitchenIndentTable;
